<div class="container-modal-loading" [ngStyle]="{'padding-bottom' : !data?.keepBrowsing ? '16px' : '0px'}">
    <loading [title]="data?.title" [description]="data?.text"></loading>
    <!-- <div *ngIf="data?.keepBrowsing" class="line"></div>
    <div *ngIf="data?.keepBrowsing" class="button-exit-modal">
        <button-induxtry (action)="handleClick($event)" (click)="stopPropagate($event)"
            [buttonProperties]="{ label: (data?.keepBrowsingText ? data.keepBrowsingText : 'KEEP BROWSING'), customStyle: 'tertiary', showLabel: true }">
        </button-induxtry>
    </div> -->
</div>
